(() => {
  if (window.hhPantryGift) return;
  const gifts = {
    cinnamon: {variant: 51347877298423, code: 'HHPANTRY-CINNAMON'},
    cream: {variant: 51347877331191, code: 'HHPANTRY-CREAM'},
    milk: {variant: 51347877363959, code: 'HHPANTRY-MILK'}
  };
  const isGift = item => item.properties?._hh_pantry_gift === 'v1' && Object.values(gifts).some(g => g.variant === Number(item.variant_id || item.id));
  const giftLines = cart => (cart.items || []).filter(isGift);
  const isGiftCode = code => /^HHPANTRY-(CINNAMON|CREAM|MILK)$/i.test(code || '');
  const codes = cart => {
    const found = (cart.discount_codes || []).map(d => typeof d === 'string' ? d : d.code);
    for (const app of cart.cart_level_discount_applications || []) if (app.type === 'discount_code') found.push(app.code || app.title);
    for (const item of cart.items || []) for (const allocation of item.line_level_discount_allocations || []) {
      const app = allocation.discount_application || {};
      if (app.type === 'discount_code') found.push(app.code || app.title);
    }
    return [...new Set(found.filter(Boolean).map(c => c.toUpperCase()))];
  };
  const paidSubtotal = cart => (cart.items || []).filter(item => !isGift(item) && !item.gift_card).reduce((total, item) => total + Number(item.original_line_price ?? Number(item.original_price || item.price || 0) * item.quantity), 0);
  const eligible = cart => cart.currency === 'AUD' && paidSubtotal(cart) >= 12000;
  const selectedKey = cart => Object.keys(gifts).find(k => giftLines(cart).some(item => Number(item.variant_id || item.id) === gifts[k].variant));
  const giftApplied = (cart, key) => {
    if (!gifts[key]) return false;
    const lines = (cart.items || []).filter(i => Number(i.variant_id || i.id) === gifts[key].variant);
    const unit = Number(lines[0]?.original_price || lines[0]?.price || 0);
    let discount = 0;
    for (const item of lines) {
      const allocations = item.line_level_discount_allocations || [];
      if (allocations.length) {
        for (const a of allocations) if ((a.discount_application?.code || a.discount_application?.title || '').toUpperCase() === gifts[key].code) discount += Number(a.amount || 0);
      } else {
        for (const d of item.discounts || []) if ((d.title || '').toUpperCase() === gifts[key].code) discount += Number(d.amount || 0);
      }
    }
    return unit > 0 && discount >= unit;
  };
  const campaign = window.hhCampaignLimits;
  const state = {gifts, isGift, giftLines, codes, paidSubtotal, eligible, selectedKey, giftApplied, isGiftCode};
  class GiftCoordinator {
    constructor() {
      this.widgets = new Set(); this.queue = Promise.resolve(); this.nativePending = 0; this.nativeChangedAt = 0;
      this.root = window.Shopify?.routes?.root || '/'; this.started = false; this.busy = false; this.blocked = false;
      document.addEventListener('hh:cart-request-start', () => { this.nativePending++; });
      document.addEventListener('hh:cart-request-end', () => { this.nativePending = Math.max(0, this.nativePending - 1); });
      document.addEventListener('change', event => {
        if (event.target.matches('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]')) this.nativeChangedAt = Date.now();
      }, true);
      document.addEventListener('submit', event => this.checkout(event), true);
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const url = new URL(link.href, location.origin);
        if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:\/|$)/i.test(url.pathname)) return;
        event.preventDefault(); this.finishCheckout(() => location.assign(link.href));
      }, true);
    }
    start() {
      if (this.started) return;
      this.started = true; this.booting = true;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'hh-pantry-gift') this.run(() => this.reconcile()).catch(() => {});
        });
      }
      this.run(() => this.reconcile()).catch(() => {}).finally(() => { this.booting = false; });
    }
    register(widget) {
      this.widgets.add(widget);
      if (this.cart) widget.paint(this.cart, this.busy);
      if (!this.started) this.start();
      else if (!this.busy && !this.booting) {
        clearTimeout(this.registerTimer);
        this.registerTimer = setTimeout(() => this.run(() => this.reconcile()).catch(() => {}), 80);
      }
    }
    unregister(widget) { this.widgets.delete(widget); }
    text(key) { return [...this.widgets][0]?.dataset[key] || campaign?.messages.error || ''; }
    notify(message, error = false) {
      this.notice = {message, error};
      for (const widget of this.widgets) {
        const status = widget.querySelector('[data-gift-status]');
        if (status) { status.textContent = message; status.classList.toggle('hh-gift__selection--error', error); }
      }
    }
    paint(cart) { document.documentElement.dataset.hhPantryGiftSelected = String(giftLines(cart).length > 0); document.documentElement.dataset.hhPantryGiftBlocked = String(this.blocked); this.cart = cart; campaign?.paint(cart, this.busy); for (const widget of this.widgets) widget.paint(cart, this.busy); if (this.notice) this.notify(this.notice.message, this.notice.error); }
    run(task) {
      clearTimeout(this.registerTimer);
      const job = this.queue.catch(() => {}).then(async () => {
        this.busy = true; document.documentElement.dataset.hhPantryGiftBusy = 'true'; if (this.cart) this.paint(this.cart);
        try { await this.waitForNative(); return await task(); }
        catch (error) { this.notify(this.text('error'), true); throw error; }
        finally { this.busy = false; document.documentElement.dataset.hhPantryGiftBusy = 'false'; if (this.cart) this.paint(this.cart); }
      });
      this.queue = job; return job;
    }
    async waitForNative() {
      const start = Date.now();
      while (this.nativePending || Date.now() - this.nativeChangedAt < 450) {
        if (Date.now() - start > 15000) throw new Error('Cart update still pending');
        await new Promise(resolve => setTimeout(resolve, 60));
      }
    }
    async request(path, body) {
      const controller = new AbortController(); const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(this.root + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, ...(body ? {body: JSON.stringify(body)} : {}), signal: controller.signal});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error('Cart request failed');
        return result;
      } finally { clearTimeout(timer); }
    }
    sectionIds() {
      return [...new Set(['cart-drawer', 'cart-icon-bubble', document.querySelector('#main-cart-items')?.dataset.id, document.querySelector('#main-cart-footer')?.dataset.id].filter(Boolean))];
    }
    update(body) { return this.request('cart/update.js', {...body, sections: this.sectionIds(), sections_url: location.pathname}); }
    async removeManaged(cart) {
      const updates = Object.fromEntries(giftLines(cart).map(item => [item.key, 0]));
      const result = await this.update({...(Object.keys(updates).length ? {updates} : {}), discount: codes(cart).filter(c => !isGiftCode(c)).join(','), attributes: {hh_pantry_gift: ''}});
      if (giftLines(result).length) throw new Error('Gift removal not confirmed');
      return result;
    }
    async refresh(cart) {
      const mappings = [
        ['cart-drawer', '#CartDrawer', '#CartDrawer'],
        ['cart-icon-bubble', '#cart-icon-bubble', '.shopify-section']
      ];
      for (const id of ['main-cart-items', 'main-cart-footer']) {
        const element = document.getElementById(id);
        if (element?.dataset.id) mappings.push([element.dataset.id, `#${id} .js-contents`, '.js-contents']);
      }
      for (const [id, targetSelector, sourceSelector] of mappings) {
        const html = cart.sections?.[id]; if (!html) continue;
        const target = document.querySelector(targetSelector);
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector(sourceSelector);
        if (target && source) target.innerHTML = source.innerHTML;
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
      }
      document.getElementById('main-cart-items')?.classList.toggle('is-empty', cart.item_count === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);
      this.paint(cart);
      document.dispatchEvent(new CustomEvent('hh:gift-updated', {detail: {cart}}));
    }
    async reconcile() {
      const incoming = await this.request('cart.js');
      const normalized = campaign ? await campaign.normalize(incoming, this) : {cart: incoming, changed: false};
      const cart = await this.reconcileGift(normalized.cart);
      if (normalized.changed) await this.refresh(cart);
      return cart;
    }
    async reconcileGift(cart) {
      const lines = giftLines(cart), key = selectedKey(cart);
      if (!lines.length) {
        if (codes(cart).some(isGiftCode)) { cart = await this.removeManaged(cart); await this.refresh(cart); }
        this.blocked = false; this.paint(cart); return cart;
      }
      if (!eligible(cart)) {
        cart = await this.removeManaged(cart); await this.refresh(cart); this.blocked = false;
        this.notify(this.text('removed')); return cart;
      }
      if (lines.length !== 1 || lines[0].quantity !== 1) {
        return this.select(key);
      }
      if (!giftApplied(cart, key)) {
        const keep = codes(cart).filter(c => !isGiftCode(c));
        cart = await this.update({discount: [...keep, gifts[key].code].join(',')});
        if (!giftApplied(cart, key)) {
          cart = await this.removeManaged(cart); await this.refresh(cart); this.blocked = false;
          this.notify(this.text('unavailable'), true); return cart;
        }
        await this.refresh(cart);
      }
      this.blocked = false; this.paint(cart); return cart;
    }
    async select(key) {
      if (!gifts[key]) return;
      let cart = await this.request('cart.js');
      const normalized = campaign ? await campaign.normalize(cart, this) : {cart, changed: false};
      cart = normalized.cart;
      if (!eligible(cart)) { if (normalized.changed) { cart = await this.reconcileGift(cart); await this.refresh(cart); } this.paint(cart); this.notify(this.text('notEligible'), true); return cart; }
      try {
        const otherCodes = codes(cart).filter(c => !isGiftCode(c));
        cart = await this.removeManaged(cart);
        this.paint(cart);
        await this.request('cart/add.js', {items: [{id: gifts[key].variant, quantity: 1, properties: {_hh_pantry_gift: 'v1'}}]});
        cart = await this.update({discount: [...otherCodes, gifts[key].code].join(','), attributes: {hh_pantry_gift: key}});
        if (!eligible(cart) || giftLines(cart).length !== 1 || !giftApplied(cart, key)) throw new Error('Gift discount not confirmed');
        this.blocked = false; await this.refresh(cart); this.notify(this.text('added'));
        document.querySelector(`hh-pantry-gift:not(.hh-gift--banner) input[value="${key}"]`)?.focus({preventScroll: true});
        return cart;
      } catch (error) {
        try { cart = await this.removeManaged(await this.request('cart.js')); await this.refresh(cart); this.blocked = false; }
        catch (cleanupError) { this.blocked = true; }
        this.notify(this.text('unavailable'), true); throw error;
      }
    }
    async remove() {
      const cart = await this.removeManaged(await this.request('cart.js'));
      this.blocked = false; await this.refresh(cart); this.notify(this.text('removedByYou')); return cart;
    }
    checkout(event) {
      if (this.allowSubmit || event.submitter?.name !== 'checkout') return;
      event.preventDefault(); const form = event.target, button = event.submitter;
      this.finishCheckout(() => {
        this.allowSubmit = true;
        try {
          const currentForm = document.getElementById(form.id) || form;
          const currentButton = button.id ? document.getElementById(button.id) : currentForm.querySelector('[name="checkout"]');
          if (currentForm.isConnected && currentButton?.form === currentForm) currentForm.requestSubmit(currentButton);
          else location.assign(this.root + 'checkout');
        } finally { this.allowSubmit = false; }
      });
    }
    async finishCheckout(proceed) {
      if (this.checkingOut) return;
      this.checkingOut = true;
      try {
        await this.run(() => this.reconcile());
        if (this.blocked) throw new Error('Gift cart needs review');
        proceed();
      } catch (error) { this.notify(this.text('error'), true); }
      finally { this.checkingOut = false; }
    }
  }
  const coordinator = new GiftCoordinator(); coordinator.state = state; window.hhPantryGift = coordinator;
  if (!customElements.get('hh-pantry-gift')) customElements.define('hh-pantry-gift', class extends HTMLElement {
    connectedCallback() {
      if (this.handler) return;
      this.handler = event => {
        if (event.target.matches('input[type="radio"]')) {
          event.stopPropagation(); this.choice = event.target.value; this.paintButtons();
        }
      };
      this.clickHandler = event => {
        const action = event.target.closest('[data-gift-add],[data-gift-remove]'); if (!action || !this.contains(action)) return;
        event.preventDefault(); event.stopPropagation(); if (coordinator.busy || action.disabled) return;
        const choice = this.choice; coordinator.notice = null;
        this.querySelectorAll('button,input').forEach(input => { input.disabled = true; });
        coordinator.run(() => action.hasAttribute('data-gift-remove') ? coordinator.remove() : coordinator.select(choice)).catch(() => {});
      };
      this.addEventListener('change', this.handler); this.addEventListener('click', this.clickHandler); coordinator.register(this);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.handler); this.removeEventListener('click', this.clickHandler);
      this.handler = null; coordinator.unregister(this);
    }
    paintButtons() {
      const add = this.querySelector('[data-gift-add]');
      if (add) { add.disabled = coordinator.busy || !this.canChoose || !this.choice || this.choice === this.current; add.textContent = coordinator.busy ? this.dataset.updating : this.current ? this.dataset.change : this.dataset.add; }
    }
    paint(cart, busy) {
      this.canChoose = eligible(cart); this.current = selectedKey(cart);
      if (this.current !== this.lastCurrent) this.choice = this.current || null;
      this.lastCurrent = this.current;
      this.setAttribute('aria-busy', String(busy));
      this.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === this.choice; input.disabled = busy; });
      this.querySelectorAll('[data-gift-remove]').forEach(button => { button.hidden = !this.current; button.disabled = busy; });
      const progress = this.querySelector('[data-gift-progress]');
      const total = paidSubtotal(cart), remaining = Math.max(0, 12000 - total);
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style: 'currency', currency: 'AUD'}).format(remaining / 100);
      const text = this.querySelector('[data-gift-progress-copy]');
      if (text) text.textContent = cart.currency !== 'AUD' ? this.dataset.audOnly : remaining ? this.dataset.remaining.replace('__AMOUNT__', money) : this.dataset.eligible;
      if (progress) { progress.hidden = cart.currency !== 'AUD'; progress.setAttribute('aria-valuenow', String(Math.min(120, total / 100))); progress.querySelector('span').style.width = Math.min(100, total / 120) + '%'; }
      const status = this.querySelector('[data-gift-status]');
      if (status && !this.classList.contains('hh-gift--banner') && !status.classList.contains('hh-gift__selection--error') && !busy) status.textContent = this.current && giftApplied(cart, this.current) ? this.dataset.added : this.dataset.hint;
      this.paintButtons();
    }
  });
  campaign?.install(coordinator);
})();

